const SvgContactAddress = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_18151_35808)">
        <path
          d="M12 2C7.31463 2 3.5 5.81463 3.5 10.5C3.5 12.6034 4.27165 14.5324 5.53906 16.0156L5.54297 16.0195L5.5459 16.0234C5.5459 16.0234 9.16186 20.1495 10.4492 21.3779C11.3113 22.1998 12.6877 22.1998 13.5498 21.3779C15.0172 19.9783 18.4551 16.0215 18.4551 16.0215L18.457 16.0186L18.46 16.0156C19.7285 14.5324 20.5 12.6034 20.5 10.5C20.5 5.81463 16.6854 2 12 2ZM12 3.5C15.8746 3.5 19 6.62537 19 10.5C19 12.2376 18.3668 13.8163 17.3193 15.041C17.3125 15.0488 13.795 19.0718 12.5146 20.293C12.2177 20.5761 11.7813 20.5761 11.4844 20.293C10.4143 19.2719 6.69055 15.0533 6.67969 15.041L6.67871 15.04C5.63266 13.8154 5 12.2371 5 10.5C5 6.62537 8.12537 3.5 12 3.5ZM12 7.5C11.0625 7.5 10.2644 7.87857 9.75195 8.45508C9.2395 9.03159 9 9.77083 9 10.5C9 11.2292 9.2395 11.9684 9.75195 12.5449C10.2644 13.1214 11.0625 13.5 12 13.5C12.9375 13.5 13.7356 13.1214 14.248 12.5449C14.7605 11.9684 15 11.2292 15 10.5C15 9.77083 14.7605 9.03159 14.248 8.45508C13.7356 7.87857 12.9375 7.5 12 7.5ZM12 9C12.5625 9 12.8894 9.18393 13.127 9.45117C13.3645 9.71841 13.5 10.1042 13.5 10.5C13.5 10.8958 13.3645 11.2816 13.127 11.5488C12.8894 11.8161 12.5625 12 12 12C11.4375 12 11.1106 11.8161 10.873 11.5488C10.6355 11.2816 10.5 10.8958 10.5 10.5C10.5 10.1042 10.6355 9.71841 10.873 9.45117C11.1106 9.18393 11.4375 9 12 9Z"
          className="fill-primary"
        />
      </g>
      <defs>
        <clipPath id="clip0_18151_35808">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgContactAddress;
